import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ExtensionDeleteConnectionModalProps, ExtensionConnectionTypes } from 'src/Libs/installation-extensions/types'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { useExtensionConnection } from 'src/Libs/installation-extensions/hooks/extensions'

/**
 * A modal to delete the connection to ai360 power share.
 */
const Ai360PowerShareDeleteConnectionModal: React.FC<ExtensionDeleteConnectionModalProps> = ({
  loadInstallationExtensionStates,
  onClose: closeAi360PowerShareDeleteConnectionModal,
  place = 0,
}) => {
  const { t } = useCustomTranslation()
  const { handleDeleteExtensionConnection } = useExtensionConnection(ExtensionConnectionTypes.Ai360PowerShare)

  const handleOnClick = async (): Promise<void> => {
    try {
      const result = await handleDeleteExtensionConnection()
      if (!result) return

      await loadInstallationExtensionStates()
      closeAi360PowerShareDeleteConnectionModal()
    } catch (e) {
      console.error('Error deleting extension connection:', e)
      closeAi360PowerShareDeleteConnectionModal()
    }
  }

  const modalActions = {
    primary: {
      name: t('common.remove'),
      onClick: handleOnClick,
    },
    secondary: { name: t('common.cancel') },
  }

  return (
    <Dialog
      title={t('installation-extensions.ai360-power-share.details.connection-deletion-modal.title')}
      onClose={closeAi360PowerShareDeleteConnectionModal}
      actions={modalActions}
      maxWidth="sm"
    >
      <Typography variant="body2" mt={4}>
        {t('installation-extensions.ai360-power-share.details.connection-deletion-modal.description')}
      </Typography>
    </Dialog>
  )
}

export default Ai360PowerShareDeleteConnectionModal
